var t = require('i18n').t

module.exports = Em.ObjectController.extend({
    needs: ['user', 'exports'],

    organization: Em.computed.oneWay('controllers.user.activeOrganization'),

    isUploading: false,

    error: null,

    importStats: false,

    helpUrl: function() {
        return t('products_import.help_url')
    }.property('organization'),

    uploadUrl: function() {
        return ENV.apiUrl + '/organizations/' + this.get('organization.id') + '/products'
    }.property('organization'),

    reloadData: function() {
        BD.store.unloadAllByType(Billy.ProductPrice)
        BD.store.unloadAllByType(Billy.Product)
        var organizationId = this.get('organization.id')
        var api = this.container.lookup('api:billy')
        return api.get('/products?include=products.prices&organizationId=' + organizationId)
            .then(function(payload) {
                var paging = payload.meta.paging
                var data = payload.products
                if (paging.total <= data.length) {
                    // Only "loadAll" if we got _all_ the products (i.e. not paged) from the server
                    BD.store.loadAll(Billy.ProductPrice, payload.productPrices)
                    BD.store.loadAll(Billy.Product, data)
                }
            })
    },

    actions: {
        exportProducts: function() {
            this.get('controllers.exports').send('exportProducts', 'xlsx')
        },

        uploadFailed: function(context) {
            this.set('error', (context.payload && context.payload.errorMessage) || t('util.request.default_error'))
                .set('importStats', null)
        },

        didUploadFile: function(context) {
            this.set('error', null)
                .set('importStats', context.payload.data)
            this.reloadData() // we reload in the background since the user stays on the same route
        }
    }
})
